import Assets from '@app/assets';

const appSettings = window['__app_settings__'] || {};

export default {
  maintenance: {
    // TODO: Move to experiments tool
    showDate: new Date(Date.UTC(2017, 6, 6, 0, 0, 0)),
    hideDate: new Date(Date.UTC(2017, 6, 9, 6, 0, 0)),
    message:
      'Sunday 9 July we have planned maintenance. Our service will be unavailable from 2:00AM CET for a few hours.',
  },
  recaptcha: {
    siteKey: window['__recaptcha__'] && window['__recaptcha__'].siteKey,
  },
  launchDarkly: {
    enabled: window['__launch_darkly__'] && window['__launch_darkly__'].enabled,
    clientID:
      window['__launch_darkly__'] && window['__launch_darkly__'].client_id,
  },
  wallpapers: {
    trackGAImpressions: false,
  },
  cookies: {
    takeover: {
      name: 'wt_takeover',
    },
    plus: {
      name: 'wt_plus',
    },
    teamOnboarded: {
      name: 'wt_team_onboarded',
    },
    signout: {
      name: 'wt_signout',
    },
    moreStorageNotification: {
      name: 'wt_more_storage_notification',
    },
  },
  subdomainName: {
    maxLength: 63,
  },
  navigation: {
    tooltip: {
      showDelay: 2000,
      hideDelay: {
        onboarding_success: 8000,
        already_signed_in: 4000,
      },
    },
  },
  textfield: {
    debounceDelay: 300,
  },
  signup: {
    yearPrice: 120,
    monthPrice: 12,
  },
  actions: {
    extended_pending: 1000,
  },
  notification: {
    animation_duration: 200,
    duration: 5000,
  },
  transfer: {
    showWarningThreshold: 518400000,
    precisionThreshold: 1024 * 1024 * 1024, // We want to show GB's with 1 decimals, and MB's without decimals
    expiryKey: {
      '1w': 'transfer.options.expire_in.1w',
      '2w': 'transfer.options.expire_in.2w',
      '1m': 'transfer.options.expire_in.1m',
      never: 'transfer.options.expire_in.never',
    },
    verificationCodeLength: 6,
  },
  route: {
    '/': {
      navStyle: {
        backgroundColor: '#6AB5BB',
      },
    },
    '/plus': {
      navStyle: {
        backgroundImage: `url(${Assets.lookup('plus/header.png')})`,
      },
    },
  },
  panel: {
    full_panel_breakpoint: 1049, // At this point, a half panel will become a full panel
    openDelay: 3000,
  },
  mobileNavHeaders: [
    Assets.lookup('curated/mobile-headers/brunomangyoku.jpg'),
    Assets.lookup('curated/mobile-headers/jasminlai.jpg'),
    Assets.lookup('curated/mobile-headers/jellemul.jpg'),
    Assets.lookup('curated/mobile-headers/latimori.jpg'),
    Assets.lookup('curated/mobile-headers/leoniebos.jpg'),
    Assets.lookup('curated/mobile-headers/monikarosesong.jpg'),
    Assets.lookup('curated/mobile-headers/spiros.jpg'),
    Assets.lookup('curated/mobile-headers/swiatkowski.jpg'),
    Assets.lookup('curated/mobile-headers/timallen.jpg'),
  ],
  avatars: [
    Assets.lookup('avatars/01.png'),
    Assets.lookup('avatars/02.png'),
    Assets.lookup('avatars/03.png'),
    Assets.lookup('avatars/04.png'),
    Assets.lookup('avatars/05.png'),
    Assets.lookup('avatars/06.png'),
    Assets.lookup('avatars/07.png'),
    Assets.lookup('avatars/08.png'),
    Assets.lookup('avatars/09.png'),
    Assets.lookup('avatars/10.png'),
    Assets.lookup('avatars/11.png'),
    Assets.lookup('avatars/12.png'),
  ],
  mobileAppBanner: {
    active: true,
    downloadUrl: 'https://wetransfer.com/products',
    downloadUrliOS:
      'https://itunes.apple.com/app/apple-store/id765359021?pt=658364&ct=wetransfer-web-popup&mt=8',
    downloadUrlAndroid:
      'https://play.google.com/store/apps/details?id=com.wetransfer.app.live&referrer=utm_source%3Dwetransfer%26utm_medium%3Dweb-popup',
    urlScheme: 'wetransfer://downloads',
    urlSchemeAndroid: 'intent://downloads',
  },
  teams: {
    roles: {
      OWNER: 'owner',
      USER: 'user',
      ADMIN: 'admin',
    },
  },
  curated_wallpapers: window['__curated_wallpapers__'] || [],
  supportedBrowsers: [
    'Chrome >= 42',
    'CriOS >= 42',
    'Firefox >= 38',
    'FxiOS >= 9',
    'Safari >= 6',
    'Explorer >= 11',
    'Edge >= 12',
  ],
  imageUpload: {
    wallpaperResolution: '1900 x 1200',
    emailBackgroundResolution: '1600 x 800',
    ...appSettings.fileSizes,
  },
  curatedPreviews: {
    mobile: 0,
    desktop: [
      {
        wallpaper: Assets.lookup(
          'curated/plus-custom/aceandtate-wallpaper.jpg'
        ),
        emailbg: Assets.lookup('curated/plus-custom/aceandtate-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/aceandtate-ava.png'),
        channel: 'aceandtate',
        brand: 'ace & tate',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/adi-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/adi-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/adi-ava.png'),
        channel: 'adidasbranddesign',
        brand: 'Adidas Brand Design',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/dennis-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/dennis-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/dennis-ava.png'),
        channel: 'dennisswiatkowski',
        brand: 'Dennis Swiatkowski',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/jamjam-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/jamjam-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/jamjam-ava.png'),
        channel: 'jamjam',
        brand: 'Jamjam marketing',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/malika-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/malika-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/malika-ava.png'),
        channel: 'malikafavre',
        brand: 'Malika Favre',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/ricardo-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/ricardo-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/ricardo-ava.png'),
        channel: 'ricardocavolo',
        brand: 'Ricardo Cavolo',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/shan-wallpaper.jpg'),
        emailbg: Assets.lookup('curated/plus-custom/shan-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/shan-ava.png'),
        channel: 'shantellmartin',
        brand: 'Shantell Martin',
      },
      {
        wallpaper: Assets.lookup('curated/plus-custom/urbanears-wallpaper.png'),
        emailbg: Assets.lookup('curated/plus-custom/urbanears-emailbg.png'),
        avatar: Assets.lookup('curated/plus-custom/urbanears-ava.png'),
        channel: 'urbanears',
        brand: 'Urbanears',
      },
    ],
  },
  stripe: {
    publishable_key:
      window['__stripe__'] && window['__stripe__'].publishable_key,
    url: 'https://js.stripe.com/v3/',
  },
  payment: {
    chargeableStatus: ['chargeable', 'consumed'],
  },
  zendesk: {
    baseUrl: 'https://wetransfer.zendesk.com/hc/en-us/',
    invalid_file_form:
      'requests/new?ticket_form_id=360000020666&request_custom_fields_360000139446=web_downloading_',
    article_transfer_duration:
      'articles/202603916-How-long-are-uploads-available-to-download-',
  },
};

// Remove global vars
if (window['__recaptcha__'] && typeof window['__recaptcha__'] === 'object') {
  window['__recaptcha__'] = null;
}
